import { API_BASE, axiosApi } from "../config"

export type OrderPlanningStatus = "yes" | "no" | "maybe" | "unavailable"

export interface OrderPlanningEntry {
    id: number
    date: string
    status: OrderPlanningStatus | null
    notes: string | null
    userid: number | null
    groupid: number
    ts: string
    firstName?: string | null
    lastName?: string | null
}

export interface GetOrderPlanningReturnInterface {
    code: number
    entries?: OrderPlanningEntry[]
    groupid?: number
    message?: string
}

export interface GetOrderPlanningHistoryReturnInterface {
    code: number
    history?: OrderPlanningEntry[]
    groupid?: number
    message?: string
}

export interface GetOrderPlanningHistoryRangeReturnInterface {
    code: number
    history?: OrderPlanningEntry[]
    groupid?: number
    message?: string
}

export interface CreateOrderPlanningEntriesReturnInterface {
    code: number
    entries?: OrderPlanningEntry[]
    groupid?: number
    message?: string
}

export async function getOrderPlanning(body: {
    startDate: string
    endDate: string
    groupid?: number
}): Promise<GetOrderPlanningReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/getOrderPlanning`, body)).data
}

export async function getOrderPlanningHistory(body: {
    date: string
    groupid?: number
}): Promise<GetOrderPlanningHistoryReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/getOrderPlanningHistory`, body)).data
}

export async function getOrderPlanningHistoryRange(body: {
    startDate: string
    endDate: string
    groupid?: number
}): Promise<GetOrderPlanningHistoryRangeReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/getOrderPlanningHistoryRange`, body)).data
}

export async function createOrderPlanningEntries(body: {
    dates: string[]
    status: OrderPlanningStatus
    notes?: string
    groupid?: number
}): Promise<CreateOrderPlanningEntriesReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/createOrderPlanningEntries`, body)).data
}
